<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="row">
        <div class="col-lg-6">
          <div class="row">
            <div class="col-lg-6 display-flex">
              <div class="col-lg-4 col-md-4 col-xs-4 pretty-input side-input-text">Created</div>
              <input type="date" v-model="filterPosts['createdFrom']" min="0" name="" placeholder="From" class="col-lg-6 col-md-6 col-xs-6 pretty-input">
              <input type="date" v-model="filterPosts['createdTo']" min="0" name="" placeholder="To" class="col-lg-6 col-md-6 col-xs-6 pretty-input">
            </div>
            <div class="col-lg-6 display-flex">
              <div class="col-lg-4 col-md-4 col-xs-4 pretty-input side-input-text">Modified</div>
              <input type="date" v-model="filterPosts['modifiedFrom']" min="0" name="" placeholder="Modification date" class="col-lg-6 col-md-6 col-xs-6 pretty-input">
              <input type="date" v-model="filterPosts['modifiedTo']" min="0" name="" placeholder="Modification date" class="col-lg-6 col-md-6 col-xs-6 pretty-input">
            </div>
          </div>
          <div class="row m-t-sm">
            <div class="col-lg-6">
              <v-select
                placeholder="External Links"
                :options="externalLinksStatus"
                index="index" label="txt"
                v-model="filterPosts['externalLinks']"
              >
              </v-select>
            </div>
            <div class="col-lg-6 display-flex">
              <div class="col-lg-4 col-md-4 col-xs-4 pretty-input side-input-text">Words</div>
              <input type="number" v-model="filterPosts['wordsFrom']" min="0" name="" placeholder="From" class="col-lg-6 col-md-6 col-xs-6 pretty-input">
              <input type="number" v-model="filterPosts['wordsTo']" min="0" name="" placeholder="To" class="col-lg-6 col-md-6 col-xs-6 pretty-input">
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="row">
            <div class="col-lg-6">
              <v-select
                placeholder="Link domain"
                :options="uniqueDomainList"
                v-model="filterLinks['linkDomain']"
              >
              </v-select>
            </div>
            <div class="col-lg-6 display-flex">
              <div class="col-lg-4 col-md-4 col-xs-4 pretty-input side-input-text">Discovery</div>
              <input type="date" v-model="filterLinks['discoveryTimeFrom']" min="0" name="" placeholder="From" class="col-lg-6 col-md-6 col-xs-6 pretty-input">
              <input type="date" v-model="filterLinks['discoveryTimeTo']" min="0" name="" placeholder="To" class="col-lg-6 col-md-6 col-xs-6 pretty-input">
            </div>
          </div>
          <div class="row m-t-sm">
            <div class="col-lg-6">
              <v-select placeholder="Index Status" :options="indexedStatus" index="index" label="txt" v-model="filterLinks['indexed']" ></v-select>
            </div>
            <div class="col-lg-6">
              <v-select
                placeholder="Link Tags"
                :options="uniqueTagList"
                multiple
                v-model="filterLinks['tag']"
              ></v-select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-6 m-t-sm">
      <table class="m-t-sm table table-striped table-bordered table-hover">
        <thead>
        <tr>
          <th>Title</th>
          <th>Created</th>
          <th>Words</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="post in filterPostTable" :key="'post' + post.id">
          <td>
            <small>
              <i class="fab fa-wordpress-simple" v-if="post.source === 'api'" v-tooltip="'WP Api'"></i>
              <i class="fas fa-spider" v-else v-tooltip="'Crawler'"></i>
              <a :href="post.url" target="_blank" :title="post.url">
                {{ shorten(post.url) }} <i class="fa fa-external-link"></i>
              </a>
              <a @click="showPostLinks(post.id)" class="btn btn-xs btn-primary m-l-sm pull-right" v-if="post.links.external">
                <span v-if="showIcon(post.id)"><i class="fa fa-link m-r-sm"></i>Show Post</span>
                <span v-if="!showIcon(post.id)"><i class="fa fa-times m-r-sm"></i>Show All</span>
                Links
              </a>
            </small><br>
            <span class="label label-success" v-if="post.indexed"><i class="fa fa-check"></i> Indexed</span>
            <span class="label label-primary m-r-xs">{{ post.language || '?' }}</span>
            <span class="label label-primary m-r-sm">{{ post.type }}</span>{{ post.title }}
            <br>
            <div class="col-lg-12 m-t-sm">
              <table>
                <tbody>
                <tr v-for="(idx, domain) in uniqueLinkDomains(post.links.external)" :key="domain" class="m-t-sm">
                  <td>
                    <span class="label label-info pull-right m-r-sm">{{ showLinkTags(post.id, domain) }}</span>
                  </td>
                  <td>
                    <a> {{ domain }} ({{ idx }})</a>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="col-lg-12 border-top m-t-sm p-h-sm" v-if="post.links.internal && post.links.internal.length">
              <a @click="showInternalLinks(post.id)">Show {{ post.links.internal.length }} internal links</a>
              <table class="table table-hover" style="display: none" :id="'internalLinks-' + post.id">
                <thead>
                <tr>
                  <th>Anchor</th>
                  <th>Link</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(link, i) in post.links.internal" :key="'internal-' + post.id + '-' + i">
                  <td>
                    {{ link.anchor || '?' }}
                  </td>
                  <td>
                    {{ link.url }}
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </td>
          <td>
            <i class="fa fa-calendar" v-tooltip="'Creation Date'"></i> {{ $moment(post.created.date).format('DD.MM.YYYY') }}<br>
            <span v-if="post.modified.date !== post.created.date"><i class="fa fa-pencil" v-tooltip="'Modification Date'"></i> {{ $moment(post.modified.date).format('DD.MM.YYYY') }}</span>
          </td>
          <td align="center">{{ post.wordCount }}</td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="col-lg-6 m-t-sm">
      <table class="m-t-sm table table-striped table-bordered table-hover">
        <thead>
        <tr>
          <th>Link</th>
          <th>Location</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(link, i) in filterLinkTable" :key="i + '-' + link" v-if="link.tag">
          <td>
            <div>
              <span v-if="(link.tag && link.tag.client && link.tag.client.id === link.pbn.client.id) || user.admin">
                <span v-if="link.tag.client && user.admin">
                  <span
                  :class="'label m-r-xs label-' + (link.tag.client.id === link.pbn.client.id ? 'primary' : 'success')"
                  >{{ link.tag.client.name }}
                  </span>
                </span>
                <span
                  v-if="link.tag && link.tag.client && tag !== 'unknown'"
                  v-for="tag in link.tag.tags"
                  :key="'link-' + i + '-' + tag"
                  :class="'label m-r-xs label-' + (link.tag.client ? 'info' : 'default')"
                >{{ tag }}</span>
              </span>
              <strong v-if="link.type === 'txt'"><i class="fa fa-link"></i> {{ link.anchor }}</strong>
              <i class="fa fa-picture-o" v-if="link.type === 'img'"></i>
              <i class="fa fa-envelope" v-if="link.type === 'email'"></i>
            </div>
            <small>
              <a :href="link.url" target="_blank">{{ shorten(link.url, 50) }} <i class="fa fa-external-link"></i></a>
              <router-link :to="'/pbn/link-tags/' + link.tag.domain" v-if="user.admin"><i class="fa fa-chart-bar"></i></router-link>
            </small>
            <small class="block">
              <i class="fa fa-search" v-tooltip="'Discovered'"></i> {{ link.discoveryTime ? $moment(link.discoveryTime.date).format('DD.MM.YYYY') : '/' }} |
              <i class="fa fa-check" v-tooltip="'Last Checked'"></i> {{ link.lastSeen | aTime('from') }}
            </small>
          </td>
          <td>
            <div>
              <span class="label label-primary" v-if="link.post.indexed"> <i class="fa fa-check"></i> Indexed</span>
              <strong>
              <i class="far fa-file-audio green" v-if="link.post.indexed"></i>
              <i class="far fa-file" v-else></i>
              {{ link.post.title }}
            </strong>
            </div>
            <small><a :href="link.post.url" target="_blank">{{ link.post.url }} <i class="fa fa-external-link"></i></a></small>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import { String, Values } from '../../../../../mixins/helperMixin'
import moment from 'moment'
export default {
  data () {
    return {
      posts: [],
      links: [],
      showInternal: {},
      filterLinks: {
        postId: null
      },
      filterPosts: {
        externalLinks: false
      },
      indexedStatus: [
        {index: null, txt: 'All'},
        {index: true, txt: 'Indexed'},
        {index: false, txt: 'Not Indexded'}
      ],
      externalLinksStatus: [
        {index: true, txt: 'Yes'},
        {index: false, txt: 'No'}
      ],
      uniqueDomainList: [],
      uniqueTagList: []
    }
  },
  mixins: [Values, String],
  watch: {
    site () {
      this.loadContent()
    }
  },
  mounted () {
    this.loadContent()
  },
  methods: {
    loadContent () {
      axios.get('/pbn/site/' + this.site.punyDomain + '/content?orderBy=indexed&orderDir=DESC')
        .then(r => {
          this.posts = r.data.data
        })
        .catch()
      axios.get('/pbn/site/' + this.site.punyDomain + '/external-links')
        .then(r => {
          this.links = r.data.data
          let domainList = this.links.map(l => l.tag.domain)
          this.uniqueDomainList = [...new Set(domainList)]
          let tagList = this.links.map(l => l.tag.tags)
          this.uniqueTagList = [...new Set([].concat.apply([], tagList))]
        })
        .catch()
    },
    showInternalLinks (id) {
      $('#internalLinks-' + id).css('display', this.showInternal[id] ? 'none' : 'block')
      this.showInternal[id] = !this.showInternal[id]
    },
    uniqueLinkDomains (externalLink) {
      if (externalLink === undefined) { return }
      let domainList = externalLink.map(l => l.linkDomain)
      let uniqueLinks = {}
      for (let domain of domainList) {
        uniqueLinks[domain] === undefined ? uniqueLinks[domain] = 1 : uniqueLinks[domain] += 1
      }
      return uniqueLinks
    },
    showLinkTags (postId, externalLinkUrl) {
      let tag = this.links.filter(l => l.post.id === postId && l.url.includes(externalLinkUrl)).map(l => l.tag.tags.filter(v => v !== 'unknown')).join()
      return tag
    },
    showPostLinks (postId) {
      this.filterLinks.postId = this.filterLinks.postId === postId ? null : postId
    },
    showIcon (postId) {
      return this.filterLinks.postId !== postId
    },
    showPostTag (postId) {
      let tagList = this.links.filter(l => l.post.id === postId).map(t => t.tag.tags)
      let mergedTagList = [].concat.apply([], tagList)
      let uniqueTags = [...new Set(mergedTagList.filter(v => v !== 'unknown'))]
      return uniqueTags
    },
    showIndexedLinks () {
      this.filterLinks['indexed'] === true ? this.filterPosts['externalLinks'] = true : this.filterPosts['externalLinks'] = this.filterPosts['externalLinks']
    }
  },
  computed: {
    ...mapGetters({
      site: 'getPbn',
      user: 'getUser'
    }),
    filterPostTable () {
      let newPosts = this.posts
      if (this.filterPosts['externalLinks']) {
        newPosts = newPosts.filter(p => Object.keys(p.links).length && p.links.external)
      }
      if (this.filterPosts['createdFrom'] || this.filterPosts['createdTo']) {
        newPosts = newPosts.filter(p => moment(p.created.date.split(' ')[0]).isBetween(this.filterPosts['createdFrom'], this.filterPosts['createdTo'], undefined, '[]'))
      }
      if (this.filterPosts['modifiedFrom'] || this.filterPosts['modifiedTo']) {
        newPosts = newPosts.filter(p => moment(p.modified.date.split(' ')[0]).isBetween(this.filterPosts['modifiedFrom'], this.filterPosts['modifiedTo'], undefined, '[]'))
      }
      if (this.filterPosts['wordsFrom'] || this.filterPosts['wordsTo']) {
        newPosts = newPosts.filter(p => p.wordCount >= this.filterPosts['wordsFrom'] && p.wordCount <= this.filterPosts['wordsTo'])
      }
      return newPosts
    },
    filterLinkTable () {
      let newLinks = this.links
      if (this.filterLinks['indexed'] != null && this.filterLinks['indexed'] !== undefined) {
        newLinks = newLinks.filter(l => l.post.indexed === this.filterLinks['indexed'])
        this.showIndexedLinks()
      }
      if (this.filterLinks['discoveryTimeFrom'] || this.filterLinks['discoveryTimeTo']) {
        newLinks = newLinks.filter(l => moment(l.discoveryTime.date.split(' ')[0]).isBetween(this.filterLinks['discoveryTimeFrom'], this.filterLinks['discoveryTimeTo'], undefined, '[]'))
      }
      if (this.filterLinks['linkDomain']) {
        newLinks = newLinks.filter(l => l.tag.domain === this.filterLinks['linkDomain'])
      }
      if (this.filterLinks['tag']) {
        newLinks = this.filterLinks['tag'].length > 0 ? newLinks.filter(l => this.filterLinks['tag'].length > l.tag.tags.length ? this.filterLinks['tag'].join().includes(l.tag.tags.join()) : l.tag.tags.join().includes(this.filterLinks['tag'].join())) : newLinks
      }
      if (this.filterLinks.postId) {
        newLinks = newLinks.filter(l => l.post.id === this.filterLinks.postId)
      }
      return newLinks
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Single/Tabs/Content.vue